export default function deepMap(value, fn) {
    return Array.isArray( value )
        ? value.map( v => deepMap( v, fn) )
        : typeof value === 'object' && value !== null
            ? Object.entries( value ).reduce( ( o, [k, v] ) => ( { ...o, [k] : deepMap( v, fn) } ),
                {} )
            : fn( value );
}
